/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiReservedPageviewMetaFromJSON, ApiReservedPageviewMetaToJSON, } from './ApiReservedPageviewMeta';
export function ApiTrackMetaPayloadFromJSON(json) {
    return ApiTrackMetaPayloadFromJSONTyped(json, false);
}
export function ApiTrackMetaPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'reserved': !exists(json, 'reserved') ? undefined : ApiReservedPageviewMetaFromJSON(json['reserved']),
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}
export function ApiTrackMetaPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'reserved': ApiReservedPageviewMetaToJSON(value.reserved),
        'value': value.value,
    };
}
